/**
 * @generated SignedSource<<20efa42d2670b0ab0c03b3cf806ed8bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupInterviewRoomSelectFieldQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  groupInterviewId?: string | null | undefined;
  search?: string | null | undefined;
};
export type GroupInterviewRoomSelectFieldQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupInterviewRoomSelectField_query">;
};
export type GroupInterviewRoomSelectFieldQuery = {
  response: GroupInterviewRoomSelectFieldQuery$data;
  variables: GroupInterviewRoomSelectFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupInterviewId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GroupInterviewRoomSelectFieldQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "groupInterviewId",
            "variableName": "groupInterviewId"
          },
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GroupInterviewRoomSelectField_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GroupInterviewRoomSelectFieldQuery",
    "selections": [
      {
        "alias": "interview",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "groupInterviewId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasActiveGroupInterviewRooms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "GroupInterviewRoomConnection",
                "kind": "LinkedField",
                "name": "groupInterviewRooms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoExtended",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupInterviewRoomEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GroupInterviewRoom",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "GroupInterviewRoomSelectField_groupInterviewRooms",
                "kind": "LinkedHandle",
                "name": "groupInterviewRooms"
              }
            ],
            "type": "GroupInterview",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d9162aacc067194a5f3433092533ca56",
    "id": null,
    "metadata": {},
    "name": "GroupInterviewRoomSelectFieldQuery",
    "operationKind": "query",
    "text": "query GroupInterviewRoomSelectFieldQuery(\n  $groupInterviewId: ID\n  $first: Int\n  $search: String\n  $after: String\n) {\n  ...GroupInterviewRoomSelectField_query_39Knml\n}\n\nfragment GroupInterviewRoomSelectField_query_39Knml on Query {\n  interview: node(id: $groupInterviewId) {\n    __typename\n    id\n    ... on GroupInterview {\n      hasActiveGroupInterviewRooms\n      groupInterviewRooms(first: $first, search: $search, after: $after) {\n        count\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n        edges {\n          node {\n            id\n            name\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d126449107d3fe2051827bdd905de16b";

export default node;
